__turbopack_context__.v({
  "active": "Vloutq_active",
  "chapter": "Vloutq_chapter",
  "chapterTimestamp": "Vloutq_chapterTimestamp",
  "chapterTitle": "Vloutq_chapterTitle",
  "chaptersContainer": "Vloutq_chaptersContainer",
  "chaptersList": "Vloutq_chaptersList",
  "panelHeader": "Vloutq_panelHeader",
  "scrollContainer": "Vloutq_scrollContainer",
});
